import React, { Component } from "react";
import {mapSexualOrientationSteps,uploadFileInstruction,mapType,reviewInstruction} from '../../../utils/constants';
import Steps from '../../Steps/Steps';
import UploadFile from '../Components/UploadFile/UploadFile';
import MatchColumns from '../Components/MatchColumns/MatchColumns';
import Review from '../Components/Review/Review';
import MapColumns from '../Components/MapColumns/MapColumns';
import groupBy from 'lodash/groupBy';
import find from 'lodash/find';
import uniqBy from 'lodash/uniqBy';
import remove from 'lodash/remove';
import findIndex from 'lodash/findIndex';
import flatten from 'lodash/flattenDeep';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import { deepClone } from "../../../utils/copyObject";
import axios from '../../../axios';
import * as url from '../../../utils/url';

export default class MapSexualOrientation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedTerm : '',
      sortType : 'unmapped-first',
      sexualOrientationOptions : [],
      perMapping:[],
      error:false
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let options 
    const orgID = this.props.user.organizationId._id
    axios.get(url.getMasterListByCategory('SEXUAL ORIENTATION')).then(({data}) => {
      console.log(data)
      const payload = data.data[0].docs;
      // console.log(payload)
       options = payload.map((i) => {
        const o = {};
        o.value = i._id;
        o.label = i.name;
        return o;
      });
      this.setState({
        sexualOrientationOptions : options
      })
    })
}

  handleFileUpload = (fields, data, file) => {
    const {matchedColumn} = this.props.mapSexualOrientation;
    
    // console.log("fields : ",fields,"includes : ",file, '--', data);
    if(matchedColumn.length > 0) {
      if(!fields.includes(matchedColumn)) {
        this.props.onMatchColumn("");
      }
    }
    this.props.onProcessedFileUploadData(fields, data, file);
    this.props.nextStep();
    // console.log("on handle file upload");
  }

  handleMapSexualOrientationContinue = () => {
    const prevMap = this.state.perMapping
    let err = this.state.error
    let {allSexualOrientationMapping} = this.props.mapSexualOrientation;
    const invalidRecords = filter(allSexualOrientationMapping,(o) => o.mapped && !o.column && o.column!=="");
    // console.log('invalid ---', invalidRecords)
    if(invalidRecords.length>0){
      this.setState({error:"Please map previously mapped values"})
      return
    } else {
      this.setState({error:false})
        this.props.nextStep()
    }
  }

  handleSexualOrientationMapped = (sexualOrientation,column) => {
    // console.log(performance,"--p---", column)
    const {allSexualOrientationMapping} = this.props.mapSexualOrientation;
    let allSexualOrientation = deepClone(allSexualOrientationMapping);
    const i = findIndex(allSexualOrientation,{value : sexualOrientation.value});
    allSexualOrientation.splice(i,1,{value:sexualOrientation.value,column:column, mapped:sexualOrientation.mapped})
    this.props.saveAllSexualOrientationMapping(allSexualOrientation);
  }

  handleMatchSexualOrientationColumn = (matchedColumn) => {
    let {rowData,allSexualOrientationMapping} = this.props.mapSexualOrientation;
    const {isRepeatFlow} = this.props;
    const uP = Object.keys(groupBy(rowData,(r) => r[matchedColumn]));
    const uniqueSexualOrientation = uP.filter(e => e!=="null")
    // console.log(uniquePerformance, isRepeatFlow);
    // console.log(allPerformanceMapping);
    this.props.onMatchColumn(matchedColumn);
    let options = this.state.sexualOrientationOptions
    const orgID = this.props.user.organizationId._id


    if(isRepeatFlow) {
      axios.get(url.getExistingMappings(orgID)).then(({data}) => {
        const payload = data.data;
        let {mapping} = payload;
        // console.log('mppaing --- ', mapping)
        if(mapping.sexualOrientation && mapping.sexualOrientation.data ){
          allSexualOrientationMapping=[]
          // console.log('inside')
          mapping.sexualOrientation.data.map(e=>{
            let column = e.key
            let obj;
              e.values.map(c=>{
                let cVal = find(options, {label:e.reference.name})
                // console.log('va--', cVal)
                obj = {column:{value: cVal.value, label:e.reference.name}, value: c, mapped:true}
                return allSexualOrientationMapping.push(obj)
              })
          })
        console.log('all ---', allSexualOrientationMapping)
        this.props.saveAllSexualOrientationMapping(allSexualOrientationMapping)  

        if(allSexualOrientationMapping.length>0){
          const filteredMapping = uniqueSexualOrientation.map((f) => {
            const found = find(allSexualOrientationMapping,(o) => o.value === f);
            if(found) {
              return {
                value : f,
                column : found.column,
                mapped:true
              }
            } else {
              return {
                value : f,
                column : '',
                mapped:false
              }
            }
          })
         
           console.log(filteredMapping,'--',allSexualOrientationMapping);
           let results = allSexualOrientationMapping.concat(filteredMapping)
           let res = results.filter(e=> e.value!=null && e.value!='null').map(e=>{
             if(e.column!==""){
               let obj = {
                 value:e.value,
                 mapped: e.mapped,
                 column: {label:e.column!==""?e.column.label:"",value: e.column?e.column.value:""}
               }
               return obj
             } else {
               let val = e.value===undefined||e.value===null ||e.value==="null"|| e.value==="undefined"? e.value="empty":e.value
               let obj = {
                 value:val,
                 mapped: false,
                 column: ""
               }
               return obj
             }
           })
           res = uniqBy(res, 'value')
           this.props.saveAllSexualOrientationMapping(res);
           this.props.nextStep();
        } else {
        this.props.saveAllSexualOrientationMapping(sortBy(filter(uniqueSexualOrientation,(p) => p != 'undefined').map((p) => {
          const g = {};
          g.value = p;
          g.column = ''
          return g;
        }),(o) => o.value));
        this.props.nextStep();
      }
    } else {
      this.props.saveAllSexualOrientationMapping(sortBy(filter(uniqueSexualOrientation,(p) => p != 'undefined').map((p) => {
        const g = {};
        g.value = p;
        g.column = ''
        return g;
      }),(o) => o.value));
      this.props.nextStep();
    }
    })
  }else {
    this.props.saveAllSexualOrientationMapping(sortBy(filter(uniqueSexualOrientation,(p) => p != 'undefined').map((p) => {
      const g = {};
      g.value = p;
      g.column = ''
      return g;
    }),(o) => o.value));
    this.props.nextStep();
  }
  

  }

  handleSearchQueryChange = ({name,value}) => {
    this.setState({
      searchedTerm : value
    })
  }

  handleContinue = () => {
    let {allSexualOrientationMapping} = this.props.mapSexualOrientation;
    const {isRepeatFlow} = this.props;
    allSexualOrientationMapping = filter(allSexualOrientationMapping,(m)=> m.column)
    // console.log('pp-----', allPerformanceMapping)
    const groupedMapping = groupBy(allSexualOrientationMapping,(m) =>  m.column.value);
    // console.log('g mapp 109 -- ' ,groupedMapping);
    let data = [];
    for(let key in groupedMapping) {
      // console.log(groupedMapping[key]);
      data.push({
        key : key,
        values : groupedMapping[key].map((o) => o.value)
      })
    }
    data = data.filter(o => o.key!==undefined && o.key!=="undefined")
    // console.log(data);
    data = data.filter(o => o.key!==undefined && o.key!=="undefined")

    const {matchedColumn} = this.props.mapSexualOrientation;
    // console.log(matchedColumn);
    const payload = {
      mappingType : "sexualOrientation",
      columnName : matchedColumn,
      data : data
    }
    console.log(payload);

    // return
    axios.post(url.saveMapping,payload).then(({data}) => {
      if(isRepeatFlow) {
        this.props.history.push({pathname : 'success',state : {type : 'sexualOrientation'}});
        this.props.reset();
      } else {
        this.props.history.push('/setup/map-separation');
      }
    })
  }

  handleonSortChange = (sortType) => {
    this.setState({
      sortType : sortType
    });
  }

  handleSkipStep = () => {
    axios.post(url.skipStepFor('sexualOrientation')).then(({data}) => {
      this.props.history.push('/setup/map-separation');
    })
  }

  render() {
    console.log(this.props);
    let {currentStep, allColumns, rowData, file, matchedColumn, 
      allSexualOrientationMapping} = this.props.mapSexualOrientation;

    const {searchedTerm,sortType,sexualOrientationOptions} = this.state;
    const {isRepeatFlow} = this.props;
    const existingMap = this.state.perMapping

    return (
      <div className={"mb30" + isRepeatFlow ? 'mt30' : 'mt70'}>
      <div className="map-performance-title mt30 mb30">Map Sexual Orientation</div>
        <Steps steps={mapSexualOrientationSteps} currentStep={currentStep} />
        {
          currentStep === 1 ? 
          <UploadFile
            top="mt40"
            instruction={uploadFileInstruction.mapSexualOrientation}
            allColumns={allColumns}
            rowData={rowData}
            file={file}
            type={mapType.sexualOrientation}
            labelSize={4}
            labelText="File with sexual orientation information"
            allowedFileSize={20}
            uploadFileHint="(Only .csv files, maximum 20MB file size)"
            onFileUpload={this.handleFileUpload}
            onSkipStep={this.handleSkipStep}
            isRepeatFlow={isRepeatFlow}
          /> : 
          currentStep === 2 ?
            <MatchColumns
              goBack={this.props.goBack}
              top="mt40"
              instruction={`Please match the column with sexual orientation information.`}
              csvFields = {allColumns}
              csvData = {rowData}
              type={mapType.sexualOrientation}
              mappingPositions={true}
              showDropdown={false}
              matchedColumns={matchedColumn!=="" ? [matchedColumn] : []}
              allowMoreColumnsMatch={false}
              nextBtnTxt='Continue'
              onMatchedColumn={this.handleMatchSexualOrientationColumn}
            /> : 
          currentStep === 3 ?
            <MapColumns
              allDataMapping={allSexualOrientationMapping}
              existingMap={existingMap}
              mapOptions={sexualOrientationOptions}
              onRowMapped={this.handleSexualOrientationMapped}
              nextStep={this.handleMapSexualOrientationContinue}
              goBack={this.props.goBack}
              searchedTerm={searchedTerm}
              sortType={sortType}
              error={this.state.error}
              onSearchQueryChange={this.handleSearchQueryChange}
              onSortChange={this.handleonSortChange}
              type={mapType.sexualOrientation}
              mapSelectPlaceholder="Map Sexual Orientation"
              optionTypeTxt="Sexual Orientation type"
              mappingTableHeader="Sexual Orientation Name"
              searchBarPlaceholder="Search by sexual orientation name..."
              mappingSubHeaderTxt="Please map your employees' sexual orientation information to standardized categories."
            /> :
          currentStep === 4 ?
            <Review
              top="mt40"
              instruction={reviewInstruction.mapSexualOrientation}
              goBack={this.props.goBack}
              nextBtnAction={this.handleContinue}
              type={mapType.sexualOrientation}
              mapOptions={sexualOrientationOptions}
              file={file}
              nextBtnTxt={isRepeatFlow ? 'Finish' : 'Next Step'}
              isRepeatFlow={isRepeatFlow}
              reviewHeading="These are your final selections for the mapping. "
              {...this.props}/>
            :
            null
        }
    </div>
    );
  }
}